import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CplCycle } from 'src/app/model/cpl-cycle.model';
import { VerifyService } from 'src/app/services/verify.service';
import { CplRosterActionsTypes } from '../../enums/cpl-roster-actions-types.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VerifyModalComponent } from 'src/app/supervision-management/compliance-items/compliance-item/modals/verify-modal/verify-modal.component';
import { CplItem } from 'src/app/model/cpl-item.model';
import { VerificationStatus } from 'src/app/supervision-management/compliance-items/compliance-item/enums/verification-status.enum';
import { ComplianceItemHelpersService } from 'src/app/services/compliance-item-helpers/compliance-item-helpers.service';
import { CycleType } from 'src/app/supervision-management/compliance-items/compliance-item/enums/cycle-type.enum';
import { UserVerification } from 'src/app/model/cycle-verification.model';
import { SessionService } from '@edl-development/edl-common';
import { RemoveUserCycleModalComponent } from 'src/app/supervision-management/compliance-items/compliance-item/modals/remove-user-cycle-modal/remove-user-cycle-modal.component';
import { MessageRequest } from 'src/app/model/message-request.model';
import { ComplyMessageService } from 'src/app/services/comply-message.service';
import { ModifyDateModalComponent } from 'src/app/supervision-management/compliance-items/compliance-item/modals/modify-date-modal.component';
import { SendMessageModalComponent } from 'src/app/supervision-management/compliance-items/compliance-item/modals/send-message-modal.component';

@Component({
    selector: 'cpl-roster-actions',
    templateUrl: './cpl-roster-actions.component.html',
    styleUrls: ['./cpl-roster-actions.component.scss']
})
export class CplRosterActionsComponent {
    private _complianceItem: CplItem;
    private _canManageItem: boolean = false;

    @Input() 
    get complianceItem() { 
        return this._complianceItem;
    }

    set complianceItem(value: CplItem) {
        this._complianceItem = value;
        this._canManageItem = this.complianceItemHelpersService.canManageItem(this._complianceItem);
    };

    @Input() cplCycle: CplCycle;
    @Input() isHistory: boolean;
    @Input() type: CplRosterActionsTypes = CplRosterActionsTypes.ALL;

    @Output() onRefreshList = new EventEmitter<void>();

    get CanManageItem() {
        return this._canManageItem;
    }

    CplRosterActionsTypes = CplRosterActionsTypes;
    VerificationStatus = VerificationStatus;

    constructor(
        public complianceItemHelpersService: ComplianceItemHelpersService,
        private ngbModal: NgbModal,
        private toastr: ToastrService,
        private verifyService: VerifyService,
        private sessionService: SessionService,
        private complyMessageService: ComplyMessageService,
    ) {}

    canPerformVerificationAction = (cplCycle: CplCycle, action: VerificationStatus) => {
        return this.complianceItemHelpersService.canPerformVerificationAction({
            CanManageItem: this.CanManageItem,
            cplCycle,
            complianceItem: this.complianceItem,
            action
        })
    }

    canRemoveHours = (cplCycle: CplCycle) => {
        return this.complianceItemHelpersService.canRemoveHours({
            CanManageItem: this.CanManageItem,
            complianceItem: this.complianceItem,
            cplCycle
        });
    }


    submitUserCycle(userCycle: CplCycle) {
        this.verifyService
            .submitForVerification(userCycle)
            .subscribe((result) => {
                this.toastr.success('Submit for Approval successfully completed.');
                this.refreshList(); 
            });
    }

    verifyUserCycle(userCycle: CplCycle) {

        if(this.complianceItem.ItemType == CycleType.ITEM && !this.isAct48Enabled()){
            let cycleVerification = new UserVerification();
            cycleVerification.VerificationID = userCycle.VerificationStage.VerificationID;
            cycleVerification.StageID = userCycle.VerificationStage.StageID;
            cycleVerification.RefId = userCycle.VerificationStage.RefId;
            cycleVerification.VerificationStatus = VerificationStatus.APPROVED;
            cycleVerification.ReopenStageId = userCycle.VerificationStage.ReopenStageId;
            cycleVerification.VerifiedBy = userCycle.VerificationStage.VerifiedBy;
            cycleVerification.VerifiedByName = userCycle.VerificationStage.VerifiedByName;
            cycleVerification.VerifiedDate = userCycle.VerificationStage.VerifiedDate;
    
            let request:UserVerification[] = new Array<UserVerification>();
            request.push(cycleVerification);
            
            this.verifyService
                .verify(request)
                .subscribe((result) => {
                    this.toastr.success('Cycle successfully approved.');
    
                    this.refreshList(); 
    
                });
        }else{
    
            let currentStatus: number = userCycle.VerificationStage.VerificationStatus;
            userCycle.VerificationStage.VerificationStatus = VerificationStatus.APPROVED;
    
            this.openVerifyModal(userCycle,VerificationStatus.APPROVED)
                .then((result: any) => {
                    this.toastr.success('Cycle successfully approved.');
                    this.refreshList(); 
                }, () => {
                    userCycle.VerificationStage.VerificationStatus = currentStatus;
                });
            
        }       
    }

    messageUserCycle(userCycle: CplCycle) {
        this.openSendMessageModal(0, userCycle.CycleID)
            .then(() => {
                this.toastr.success('Message successfully sent to ' + userCycle.FirstName + ' ' + userCycle.LastName + '.');
            }, () => {});
    }

    nudgeUserCycle(userCycle: CplCycle) {
        let message: MessageRequest = new MessageRequest();
        message.Target = 0;
        message.TypeID.push(userCycle.CycleID);

        this.complyMessageService
            .nudge(message)
            .subscribe(() => {
                this.toastr.success(userCycle.FirstName + ' ' + userCycle.LastName + ' successfully nudged.');
            });
    }

    modifyUserCycle(userCycle: CplCycle) {
        this.openModifyDate(userCycle)
            .then(() => {
                this.refreshList(); 
            });
    }

    removeUserCycle(userCycle: CplCycle) {
        this.openRemoveUserCycle(this.complianceItem.ItemID, userCycle.UserID, this.complianceItem.SendWelcomeEmail)
            .then(() => {
                this.toastr.success('Cycle successfully removed.');
                this.refreshList(); 
            })
    }

    reopenUserCycle(userCycle: CplCycle) {
        if(userCycle.VerificationStage !== null){
            
            userCycle.VerificationStage.VerificationStatus = VerificationStatus.REOPEN;
        }else{
            let cycleVerification = new UserVerification();
            cycleVerification.RefId = userCycle.CycleID;
            cycleVerification.VerificationStatus = VerificationStatus.REOPEN;
            cycleVerification.VerifiedBy = this.sessionService.user.UserID;
            cycleVerification.VerifiedDate = new Date();
            userCycle.VerificationStage = cycleVerification;
        }
        let currentStatus: number = userCycle.VerificationStage.VerificationStatus;

        this.openVerifyModal(userCycle, VerificationStatus.REOPEN)
            .then((result: any) => {
                this.toastr.success('Cycle successfully reopened.');
                this.refreshList(); 
            }, () => {
                userCycle.VerificationStage.VerificationStatus = currentStatus;
            });
    }

    forgiveUserCycle(userCycle: CplCycle) {
        if(userCycle.VerificationStage !== null){
            
            userCycle.VerificationStage.VerificationStatus = VerificationStatus.FORGIVEN;
        }else{
            let cycleVerification = new UserVerification();
            cycleVerification.RefId = userCycle.CycleID;
            cycleVerification.VerificationStatus = VerificationStatus.FORGIVEN;
            cycleVerification.VerifiedBy = this.sessionService.user.UserID;
            cycleVerification.VerifiedDate = new Date();
            userCycle.VerificationStage = cycleVerification;
        }
        let currentStatus: number = userCycle.VerificationStage.VerificationStatus;

        this.openVerifyModal(userCycle, VerificationStatus.FORGIVEN)
            .then((result: any) => {
                this.toastr.success('Cycle successfully forgiven.');
                this.refreshList(); 
            }, () => {
                userCycle.VerificationStage.VerificationStatus = currentStatus;
            });
    }

    disapproveUserCycle(userCycle: CplCycle) {
        let currentStatus: number = userCycle.VerifiedStatus;
        userCycle.VerifiedStatus = VerificationStatus.DECLINED;

        this.openVerifyModal(userCycle, VerificationStatus.DECLINED)
            .then((result: any) => {
                this.toastr.success('Cycle successfully disapproved.');
                this.refreshList(); 
            }, () => {
                userCycle.VerifiedStatus = currentStatus;
            });
    }

    private refreshList() {
        this.onRefreshList.emit();
    }

    private isAct48Enabled() {
        return this.complianceItemHelpersService.isAct48Enabled(this.complianceItem);
    }

    private openSendMessageModal(target: number, typeId: string) {
        let modalRef = this.ngbModal.open(SendMessageModalComponent, {
            size: 'lg',
            backdrop: 'static'
        });

        modalRef.componentInstance.target = target;
        modalRef.componentInstance.typeId = typeId;

        return modalRef.result;
    }

    private openModifyDate(userCycle: CplCycle){
        let modalRef = this.ngbModal.open(ModifyDateModalComponent, {
            backdrop: 'static',
        });
        modalRef.componentInstance.cycle = userCycle;
        modalRef.componentInstance.complianceItem = this.complianceItem;
        modalRef.componentInstance.individualAction = true;
        return modalRef.result;

    }

    private openRemoveUserCycle(itemId: string, userId: string, shouldSendNotifications: boolean) {
        const modalRef = this.ngbModal.open(RemoveUserCycleModalComponent);
        modalRef.componentInstance.itemId = itemId;
        modalRef.componentInstance.userIds = [userId];
        modalRef.componentInstance.shouldSendNotifications = shouldSendNotifications;

        return modalRef.result;        
    }

    private openVerifyModal(userCycle: CplCycle, VerifyAction: number) {
        let modalRef = this.ngbModal.open(VerifyModalComponent, {
            size: 'lg',
            backdrop: 'static'
        });

        modalRef.componentInstance.complianceItem = this.complianceItem;
        modalRef.componentInstance.userCycle = userCycle;
        modalRef.componentInstance.action = VerifyAction;

        return modalRef.result;
    }
}
